import { createContext, useContext, Context } from 'react';

import { useGlobalStore } from '../globalStore';

const _NullContext = createContext<unknown>(undefined);

export default function useStoreWithValidation<T>(
  name: string,
  options: {
    hook: string;
    provider: string;
    shouldThrowError: false;
    /** Optional React context to fall back to when the global store is absent. */
    context?: Context<T>;
  },
): T | undefined;
export default function useStoreWithValidation<T>(
  name: string,
  options: {
    hook: string;
    provider: string;
    shouldThrowError?: true;
    /** Optional React context to fall back to when the global store is absent. */
    context?: Context<T>;
  },
): T;
export default function useStoreWithValidation<T>(
  name: string,
  options: {
    hook: string;
    provider: string;
    shouldThrowError?: boolean;
    /** Optional React context to fall back to when the global store is absent. */
    context?: Context<T>;
  },
): T | undefined {
  const store = useGlobalStore<T>(name);
  const { hook, provider, shouldThrowError, context } = options;

  const contextValue = useContext((context ?? _NullContext) as Context<T>);

  const shouldError = shouldThrowError ?? true;

  const value = store ? store() : contextValue;

  if ((value === null || value === undefined) && shouldError) {
    throw new Error(`${hook} must be used within a ${provider}`);
  }

  return value;
}
